// extracted by mini-css-extract-plugin
module.exports = {"input":"Textarea_input__lRFX_","text":"Textarea_text__JAgR-"};